// Advanced Buttons JavaScript
document.addEventListener('DOMContentLoaded', function() {
  
  // Pay Now Button with Sound Effect
  function initPayNowButtons() {
    document.querySelectorAll('.btn-pay-now').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Show payment card animation
        showPaymentAnimation();
        
        // Play success sound after animation
        setTimeout(() => {
          playSuccessSound();
          showSuccessMessage();
        }, 2000);
      });
    });
  }
  
  // Show Payment Card Animation
  function showPaymentAnimation() {
    const modal = document.createElement('div');
    modal.className = 'payment-modal';
    modal.innerHTML = `
      <div class="payment-modal-backdrop" onclick="closePaymentModal()">
        <div class="payment-modal-content" onclick="event.stopPropagation()">
          <div class="payment-card-container">
            <div class="payment-left-side">
              <div class="payment-card">
                <div class="payment-card-line"></div>
                <div class="payment-card-buttons"></div>
              </div>
              <div class="payment-post">
                <div class="payment-post-line"></div>
                <div class="payment-screen">
                  <div class="payment-dollar">$</div>
                </div>
                <div class="payment-numbers"></div>
                <div class="payment-numbers-line2"></div>
              </div>
            </div>
            <div class="payment-right-side">
              <div class="payment-new-text">Processing Payment...</div>
              <svg viewBox="0 0 451.846 451.847" height="512" width="512" class="payment-arrow">
                <path fill="#cfcfcf" d="M345.441 248.292L151.154 442.573c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744L278.318 225.92 106.409 54.017c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.287 194.284c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z"/>
              </svg>
            </div>
          </div>
          <button class="close-payment-btn" onclick="closePaymentModal()">×</button>
        </div>
      </div>
    `;
    
    // Add modal styles
    const modalStyles = `
      <style>
        .payment-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 10000;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .payment-modal-backdrop {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.8);
          backdrop-filter: blur(10px);
        }
        
        .payment-modal-content {
          position: relative;
          z-index: 1;
          animation: modalSlideIn 0.3s ease;
        }
        
        .close-payment-btn {
          position: absolute;
          top: -40px;
          right: 0;
          background: white;
          border: none;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: translateY(50px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      </style>
    `;
    
    document.head.insertAdjacentHTML('beforeend', modalStyles);
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    
    // Auto close after 3 seconds
    setTimeout(() => {
      closePaymentModal();
    }, 3000);
  }
  
  // Close Payment Modal
  window.closePaymentModal = function() {
    const modal = document.querySelector('.payment-modal');
    if (modal) {
      modal.remove();
      document.body.style.overflow = 'auto';
    }
  }
  
  // Play Success Sound
  function playSuccessSound() {
    // Create audio context for success sound
    if (typeof(AudioContext) !== "undefined" || typeof(webkitAudioContext) !== "undefined") {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      
      // Success sound frequencies
      const frequencies = [523.25, 659.25, 783.99]; // C5, E5, G5
      
      frequencies.forEach((freq, index) => {
        setTimeout(() => {
          const oscillator = audioContext.createOscillator();
          const gainNode = audioContext.createGain();
          
          oscillator.connect(gainNode);
          gainNode.connect(audioContext.destination);
          
          oscillator.frequency.value = freq;
          oscillator.type = 'sine';
          
          gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
          gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
          
          oscillator.start(audioContext.currentTime);
          oscillator.stop(audioContext.currentTime + 0.3);
        }, index * 100);
      });
    }
  }
  
  // Show Success Message
  function showSuccessMessage() {
    const successDiv = document.createElement('div');
    successDiv.className = 'payment-success-message';
    successDiv.innerHTML = `
      <div class="success-icon">✓</div>
      <div class="success-text">Payment Successful!</div>
    `;
    
    const successStyles = `
      <style>
        .payment-success-message {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #22c55e;
          color: white;
          padding: 20px 30px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          gap: 15px;
          z-index: 10001;
          font-weight: 600;
          box-shadow: 0 10px 30px rgba(34, 197, 94, 0.3);
          animation: successPop 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }
        
        .success-icon {
          width: 30px;
          height: 30px;
          background: rgba(255,255,255,0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
        }
        
        @keyframes successPop {
          0% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.5);
          }
          70% {
            transform: translate(-50%, -50%) scale(1.1);
          }
          100% {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
          }
        }
      </style>
    `;
    
    document.head.insertAdjacentHTML('beforeend', successStyles);
    document.body.appendChild(successDiv);
    
    // Remove success message after 2 seconds
    setTimeout(() => {
      successDiv.remove();
    }, 2000);
  }
  
  // Initialize all advanced buttons
  initPayNowButtons();
});
